import { useAuthQuery } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';
import { UserApi } from 'api';
import { SearchUserQueryType } from 'types';

function useGetAll(query: SearchUserQueryType) {
  return useAuthQuery(
    getQueryKeys([KEY]).list({ ...query }),
    () => UserApi.getAll(query),
    {
      select: (data) => data.data,
    },
  );
}

export default useGetAll;
